import { motion } from "framer-motion";
import { useLang } from "../i18n";

export const Manifesto = () => {
  const { t, isAr } = useLang();
  return (
    <section id="story" className="py-24 md:py-32 px-6 md:px-12 max-w-[1400px] mx-auto" data-testid="manifesto-section">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.35em] text-gold font-semibold mb-16"
      >
        {t.manifesto.kicker}
      </motion.p>
      <div>
        {t.manifesto.chapters.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="grid md:grid-cols-12 gap-6 md:gap-12 py-12 md:py-16 border-t border-line group"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <div className="md:col-span-3">
              <span className="font-display font-light text-7xl md:text-8xl text-outline-gold group-hover:text-gold group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.num}
              </span>
            </div>
            <div className="md:col-span-4">
              <h3 className="font-display font-light text-3xl md:text-4xl text-pine tracking-tight">{c.title}</h3>
              <p className={`${isAr ? "font-display italic" : "font-arabic"} text-gold/90 text-xl mt-3`}>{c.side}</p>
            </div>
            <div className="md:col-span-5">
              <p className="text-smoke text-base md:text-lg leading-relaxed">{c.copy}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
